export const RELEVANT_FIELDS_NAMES = [
    'CUSTDES',
    'CUSTNAME',
    'PHONE',
    'EMAIL',
    'ADDRESS',
    'STATEA',
    'STATENAME',
    'ZIP',
    'COUNTRYNAME',
    'BRANCHNAME',
    'STATDES'
];
export const CUSTOMER_FORM_NAME = 'CUSTOMERS';
export const PREVENT_SEARCH_FIEDS = ['CUSTNAME', 'CUSTDES'];
export const CUSTOMER_FIELD_NAME = 'CUSTNAME';
export const MAKE_CUST_NAME = 'MAKECUST';
export const FORM_FIELD_NAME = 'QUICK_CUST_INPUT_NAME';
